import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, switchMap, take } from 'rxjs';
import { LicenseType } from '../models/public-payment-info';
import { PaymentService } from '../services/payment.service';
import { TenantAccessService } from '../services/tenant-access.service';

export const licenseTypeGuard = (allowedLicenseTypes: LicenseType[]) => {
    return (route: ActivatedRouteSnapshot) => {
        const paymentService = inject(PaymentService);
        const tenantAccess = inject(TenantAccessService);
        const router = inject(Router);

        const tenant =
            route.pathFromRoot.reduce<string | undefined>((found, r) => found ?? r.params.tenant, undefined) ??
            tenantAccess.getTenantAccessSnapshot()?.uid;

        if (!tenant) {
            return router.createUrlTree(['/']);
        }

        const checkLicense$ = paymentService.getLicenseType().pipe(
            take(1),
            map((licenseType) =>
                allowedLicenseTypes.includes(licenseType) ? true : router.createUrlTree([tenant, 'prompts']),
            ),
        );

        if (tenantAccess.getTenantAccessSnapshot()?.uid === tenant) {
            return checkLicense$;
        } else {
            return tenantAccess.loadTenantAccess(tenant).pipe(switchMap(() => checkLicense$));
        }
    };
};
